import axios from './axios';

export default {
  get: async query => {
    const params = { params: query };
    const { data } = await axios.get('/template-forms', params);
    return data;
  },

  getMinResponse: async query => {
    const params = { params: query };
    const { data } = await axios.get('/template-forms/marketplace', params);
    return data;
  },

  getById: async id => {
    const { data } = await axios.get(`/template-forms/${id}`);
    return data;
  },

  create: async body => {
    const { data } = await axios.post(`/template-forms`, body);
    return data;
  },

  update: async (id, body) => {
    const { data } = await axios.put(`/template-forms/${id}`, body);
    return data;
  },

  delete: async id => {
    const { data } = await axios.delete(`/template-forms/${id}`);
    return data;
  },

  addToFavorites: async (id, body) => {
    const { data } = await axios.put(`/template-forms/${id}/favorites`, body);
    return data;
  },

  deleteFromFavorites: async id => {
    const { data } = await axios.delete(`/template-forms/${id}/favorites`);
    return data;
  },

  kindValues: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/template-forms/kind/values`, params);
    return data;
  }
};
